export const typography = {
  fontSizes: {
    heading: {
      xs: "14px",
      s: "16px",
      m: "20px",
      l: "24px",
      xl: "30px",
      "2xl": "36px",
      "3xl": "48px",
      "4xl": "60px"
    },
    body: {
      xxxs: "8px",
      xxs: "10px",
      xs: "12px",
      s: "14px",
      m: "16px",
      l: "18px",
      xl: "20px",
      "2xl": "24px",
      "3xl": "30px"
    }
  },
  fonts: {
    heading: `Plus Jakarta Sans, sans-serif`,
    body: `Plus Jakarta Sans, sans-serif`,
    mono: `Plus Jakarta Sans, sans-serif`
  },
};

